"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUnavOvertimeStats = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const UNAV_OVERTIME_STATS_QUERY = (0, graphql_tag_1.default) `
  query OverTimeStats($period: PeriodInput!, $workspaceId: ID!) {
    workspace(id: $workspaceId) {
      overTimeStats(period: $period) {
        currentPendingTimeOffInLieuMinutes
        userId
      }
    }
  }
`;
const requestUnavOvertimeStats = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(UNAV_OVERTIME_STATS_QUERY, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace.overTimeStats;
};
exports.requestUnavOvertimeStats = requestUnavOvertimeStats;
